import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  Box,
  Breadcrumbs,
  Button,
  CardActionArea,
  CardMedia,
  Divider,
  Grid,
  TextField,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";

function predictMachinefailure(formData) {
  const apiURL = process.env.REACT_APP_APIURL;

  return new Promise((resolve, reject) => {
    axios({
      method: "GET",
      url: apiURL + "/machinefailurepredict",

      headers: {
        "Content-Type": "application/json",
        // Authorization: "Bearer " + process.env.REACT_APP_API_TOKEN,
        Authorization: process.env.REACT_APP_API_TOKEN_TEST,
      },
      params: { ...formData },
    })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
  // id, content, author, parentnode, regdate
}

const MachineFailure = () => {
  const [formData, setFormData] = useState({
    air_temperature: "",
    process_temperature: "",
    rotational_speed: "",
    torque: "",
    tool_wear: "",
  });

  const handleChangeForm = (e) => {
    const { value, name } = e.target;
    const regex = /^[0-9]*\.?[0-9]*$/;

    if (regex.test(value) || value === "") {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const predictResult = () => {
    const result = predictMachinefailure(formData);
  };

  return (
    <>
      <div id="content">
        <Box sx={{ mt: 3, mb: 3 }}>
          <Box sx={{ mt: 3, mb: 3 }}>기계 고장 예측</Box>
          <Box component="form" autoComplete="off" onSubmit={predictResult}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  id="air_temperature"
                  label="Air temperature [K]"
                  name="air_temperature"
                  value={formData.air_temperature}
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="process_temperature"
                  label="Process temperature [K]"
                  name="process_temperature"
                  value={formData.process_temperature}
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="rotational_speed"
                  label="Rotational speed [rpm]"
                  name="rotational_speed"
                  value={formData.rotational_speed}
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="torque"
                  label="Torque [Nm]"
                  name="torque"
                  value={formData.torque}
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="tool_wear"
                  label="Tool wear [min]"
                  name="tool_wear"
                  value={formData.tool_wear}
                  onChange={handleChangeForm}
                />
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained">고장 예측</Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </div>
      {/* #content end*/}
    </>
  );
};

export default MachineFailure;
